import React from 'react';
import { Box, Grid, List, ListItem, Typography } from '@mui/material';
import BuilderSelct from '@/store/builderStoreSelector';
import { BuilderRoomAsset, BuilderRoomAssets, Texture, TwoDMesh } from '@/store/builderSlice';
import { actions as builderActions } from "@/store/builderSlice";
import { useDispatch } from 'react-redux';
import { ProductPlacementType, SurfaceType } from '@/utils/builder/builderConstants';
import DraggableThumbnail from './DraggableThumbnail';
import { CustomDragPreview } from './ProductListView';
import { v4 as uuid } from 'uuid';


const DoorsAndWindowsTray = (props: { type: string; }) => {
  const dispatch = useDispatch();
  const roomAssets: BuilderRoomAssets = BuilderSelct.roomAssets();
  const currentWallId: string = BuilderSelct.twoDRoomLayout().activeWallId;
  const currentAssets = props.type === 'door' ? roomAssets.doorTypes : roomAssets.windowTypes;

  const updateFloorTexture = (texture: Texture) => {
    dispatch(builderActions.addProductToProject({
      productId: texture.id,
      surfaceType: SurfaceType.FLOOR,
      surfaceId: SurfaceType.FLOOR,
      type: ProductPlacementType.Texture,
      undoable: true,
    }));
  }

  const addObjecToWall = (roomAsset: BuilderRoomAsset) => {
    if (currentWallId == null || currentWallId === '') {
      dispatch(builderActions.updateTwoDUi({
        showSelectWallTooltip: true
      }));
      return;
    }

    const mesh = {
      id: uuid(),
      type: props.type,
      subType: roomAsset.type,
      width: props.type === 'door' ? 2.5 : 3
    } as TwoDMesh;

    dispatch(builderActions.addTwoDWallMeshChild({
      //@ts-ignore
      wallId: currentWallId,
      wallMesh: mesh,
      undoable: true
    }));
  }

  return (
    <List sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto', width: '100%', maxWidth: 120, bgcolor: 'background.paper' }}>
      {currentAssets.map((roomAsset: BuilderRoomAsset) => (
        <ListItem key={roomAsset._id} alignItems="flex-start" onClick={() => addObjecToWall(roomAsset)}>
          <Grid container justifyContent="center">
            <CustomDragPreview />
            <DraggableThumbnail
              id={roomAsset._id}
              url={roomAsset.twoDimentionalUrl}
              asset={Object.assign({}, roomAsset, { assetType: props.type })}
              tooltipText={'Click to add it to the wall'}
            />
            <Typography variant="body2"
              sx={{
                color: 'primary',
                paddingTop: '5px',
                lineHeight: '15px',
                textAlign: 'center'
              }}>{roomAsset.type}</Typography>
          </Grid>
        </ListItem>
      ))}
    </List>
  );
}
export default DoorsAndWindowsTray;